export default `float de(vec3 p){
    float r = 1.; 

    return fGDF(p, r, 3, 6);
  }

With Exponent

  float de(vec3 p){
    float r = 1.; 
    float e = 1.; 

    return fGDF(p, r, e, 3, 6);
  }`